module.exports = __webpack_public_path__ + "static/media/mobile_taxionline.1aa557ea.png";